/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{styleHookSingleton as r}from"./hook.js";var n=function(){var n=r();return function(r){var o=r.styles,t=r.dynamic;return n(o,t),null}};export{n as styleSingleton};
//# sourceMappingURL=component.js.map
